const map = {
	"./antiestres.svg": 9009,
	"./antiestres_tag.svg": 7404,
	"./antimicrobianos.svg": 8421,
	"./antimicrobianos_tag.svg": 8632,
	"./articulos-cuidado-personal-covid-19.svg": 2143,
	"./articulos-cuidado-personal-covid-19_tag.svg": 5226,
	"./articulos-de-escritura.svg": 3280,
	"./articulos-de-escritura_tag.svg": 5209,
	"./articulos-home-office-teletrabajo.svg": 980,
	"./articulos-home-office-teletrabajo_tag.svg": 3653,
	"./articulos-reflectivos-y-de-precaucion.svg": 2556,
	"./articulos-reflectivos-y-de-precaucion_tag.svg": 9021,
	"./automovil.svg": 3255,
	"./automovil_tag.svg": 5362,
	"./bar-y-vino.svg": 9335,
	"./bar-y-vino_tag.svg": 7042,
	"./basket.svg": 8989,
	"./bicicleta.svg": 8647,
	"./bicicleta_tag.svg": 7906,
	"./calculadoras.svg": 7427,
	"./calculadoras_tag.svg": 3254,
	"./cart.svg": 6849,
	"./chevron-left.svg": 2526,
	"./chevron-right.svg": 9501,
	"./close.svg": 5837,
	"./confecciones.svg": 178,
	"./confecciones_tag.svg": 1987,
	"./deportes.svg": 8223,
	"./deportes_megamenu_icon.svg": 2296,
	"./deportes_tag.svg": 3482,
	"./downArrow.svg": 7526,
	"./eco-nature.svg": 8562,
	"./eco-nature_tag.svg": 6947,
	"./ecologia-ecopromo.svg": 6963,
	"./ecologia-ecopromo_tag.svg": 3638,
	"./email.svg": 1089,
	"./empty.svg": 1718,
	"./facebook.svg": 3479,
	"./form.svg": 217,
	"./golf.svg": 111,
	"./golf_tag.svg": 9466,
	"./gorras.svg": 5025,
	"./gorras_tag.svg": 1116,
	"./herramientas.svg": 2280,
	"./herramientas_tag.svg": 1073,
	"./hogar.svg": 5250,
	"./hogar_megamenu_icon.svg": 7034,
	"./hogar_tag.svg": 8451,
	"./iluminacion.svg": 919,
	"./iluminacion_tag.svg": 2066,
	"./infantil.svg": 2144,
	"./infantil_tag.svg": 2521,
	"./instagram.svg": 5373,
	"./juegos-y-entretenimiento.svg": 1141,
	"./juegos-y-entretenimiento_megamenu_icon.svg": 6021,
	"./juegos-y-entretenimiento_tag.svg": 1592,
	"./llaveros.svg": 2949,
	"./llaveros_tag.svg": 2664,
	"./maletines-y-bolsos.svg": 2388,
	"./maletines-y-bolsos_tag.svg": 3685,
	"./marcas-exclusivas.svg": 3782,
	"./marcas-exclusivas_tag.svg": 4719,
	"./master-line.svg": 4612,
	"./master-line_tag.svg": 7125,
	"./master_line_megamenu_icon.svg": 942,
	"./medicos-y-farmaceuticos.svg": 5008,
	"./medicos-y-farmaceuticos_tag.svg": 6153,
	"./megamenu_icon.svg": 3504,
	"./memorias-usb.svg": 9351,
	"./memorias-usb_tag.svg": 4661,
	"./mugs-botilitos-vasos-y-termos.svg": 7745,
	"./mugs-botilitos-vasos-y-termos_tag.svg": 7644,
	"./nature.svg": 8498,
	"./nuevos-productos-2025.svg": 105,
	"./nuevos-productos-2025_tag.svg": 6724,
	"./oficina.svg": 3922,
	"./oficina_tag.svg": 3299,
	"./paraguas-e-impermeables.svg": 5852,
	"./paraguas-e-impermeables_tag.svg": 2189,
	"./pharma-y-cuidado-personal.svg": 1563,
	"./pharma-y-cuidado-personal_tag.svg": 6126,
	"./phone.svg": 6345,
	"./pla-acido-polilactico.svg": 1575,
	"./pla-acido-polilactico_tag.svg": 5858,
	"./produccion-nacional.svg": 5935,
	"./produccion-nacional_tag.svg": 250,
	"./productos-futbol.svg": 7567,
	"./productos-futbol_tag.svg": 5130,
	"./relojes.svg": 443,
	"./relojes_tag.svg": 734,
	"./sanitized.svg": 1666,
	"./sanitized_tag.svg": 6339,
	"./search-icon.svg": 5691,
	"./search.svg": 4343,
	"./select-product.svg": 4689,
	"./send-email.svg": 2242,
	"./shirts.svg": 4644,
	"./shopping-bag.svg": 3078,
	"./smartCoti.png": 5042,
	"./sports_megamenu_icon.svg": 4554,
	"./tecnologia.svg": 2348,
	"./tecnologia_tag.svg": 6317,
	"./tool_megamenu_icon.svg": 9017,
	"./user.svg": 698,
	"./variedades.svg": 4355,
	"./variedades_tag.svg": 4518,
	"./wp.svg": 5298
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9443;